import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { objectActions, getObjectsAndFields } from "../objectApi"

class WithObjects extends React.Component {
    render() {
        const objectsData = this.props.objects
        if (!objectsData) return this.props.loading ? this.props.loading : ""
        const objects = Object.values(objectsData).filter(obj => !obj.is_metadata)
        return this.props.children({
            objects,
            createObject: this.props.objectActions.create,
        })
    }

    constructor(props) {
        super(props)
        props.objectActions.fetch()
    }
}

WithObjects.propTypes = {}

function mapStateToProps(state) {
    return {
        objects: getObjectsAndFields(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        objectActions: bindActionCreators(objectActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithObjects)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithObjects.js